import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SUBMIT_SCENARIO } from "@/constants/testIds";

export function ScenarioDetailsForm({ title, content, mediaFile, submitLabel, loading, onTitleChange, onContentChange, onFileChange }) {
  return (
    <>
      <div>
        <Label htmlFor="title" className="text-zinc-500 text-xs uppercase tracking-wide">Title</Label>
        <Input
          id="title" required value={title} onChange={(e) => onTitleChange(e.target.value)}
          placeholder="A short, clear summary"
          data-testid={SUBMIT_SCENARIO.titleInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div>
        <Label htmlFor="content" className="text-zinc-500 text-xs uppercase tracking-wide">What happened?</Label>
        <Textarea
          id="content" required rows={6} value={content} onChange={(e) => onContentChange(e.target.value)}
          placeholder="Describe what happened in plain language — no need for legal or academic terms."
          data-testid={SUBMIT_SCENARIO.contentInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div>
        <Label className="text-zinc-500 text-xs uppercase tracking-wide mb-2 block">Add a video (optional)</Label>
        <label className="flex items-center gap-3 border border-dashed border-zinc-300 rounded-sm p-4 cursor-pointer hover:border-zinc-950 transition-colors">
          <Upload className="h-5 w-5 text-zinc-400" />
          <span className="text-sm text-zinc-500">{mediaFile ? mediaFile.name : "Upload a reenactment or personal-story video"}</span>
          <input type="file" accept="video/*,image/*" onChange={(e) => onFileChange(e.target.files?.[0] || null)} data-testid={SUBMIT_SCENARIO.mediaUploadInput} className="hidden" />
        </label>
      </div>
      <Button type="submit" disabled={loading} data-testid={SUBMIT_SCENARIO.submitButton} className="w-full bg-zinc-950 text-white font-medium rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
        {submitLabel}
      </Button>
    </>
  );
}
